module.exports = __webpack_public_path__ + "static/wix.8065d760.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/wix.png
// module id = 864
// module chunks = 73261030922168